import { render, staticRenderFns } from "./live2.vue?vue&type=template&id=0822999f&scoped=true"
import script from "./live2.vue?vue&type=script&lang=js"
export * from "./live2.vue?vue&type=script&lang=js"
import style0 from "./live2.vue?vue&type=style&index=0&id=0822999f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822999f",
  null
  
)

export default component.exports